const SJ = {
  BLZT: {type: 'sjcz_blzt', name: '办理状态'},
  LZXW: {type: 'sjcz_lzxw', name: '流转行为'},
  SJDJ: {type: 'sjcz_sjdj', name: '事件等级'},
  SJFL: {type: 'sjcz_sjfl', name: '事件分类'},
  SJGM: {type: 'sjcz_sjgm', name: '事件规模'},
  SJLY: {type: 'sjcz_sjly', name: '事件来源'},
  SJZT: {type: 'sjcz_sjzt', name: '事件状态'},
}
export default SJ
